export default {"src":"/_next/static/media/contacts.e052b110.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};